var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarketResearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.93344 9.15698H0V26.9572H5.93344V9.15698Z",
    fill: "#7B2A7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7567 13.9066C17.4421 14.3279 17.27 14.8384 17.27 15.372C17.27 16.0309 17.525 16.6422 17.988 17.1045C18.4509 17.5675 19.068 17.8225 19.7205 17.8225C20.3735 17.8225 20.9906 17.5675 21.453 17.1109C22.3256 16.2383 22.4027 14.8679 21.6785 13.9067L17.7567 13.9066Z",
    fill: "#7B2A7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6112 23.1566V26.96H22.5447V23.2632C21.6488 23.5837 20.6939 23.7499 19.7205 23.7499C18.641 23.75 17.5846 23.5426 16.6112 23.1566Z",
    fill: "#7B2A7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3488 15.372C11.3488 13.1354 12.2145 11.0349 13.7986 9.45071C13.9412 9.3082 14.0838 9.17142 14.2379 9.04686V2.03979H8.3045V26.9601H14.2379V21.7029C14.0838 21.5783 13.9412 21.4422 13.7986 21.2996C12.2145 19.7154 11.3488 17.615 11.3488 15.372Z",
    fill: "#7B2A7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4624 22.0673L25.261 18.9488C25.9436 17.8931 26.3133 16.6636 26.3133 15.3742C26.3133 13.6105 25.6278 11.9545 24.3837 10.7104C23.1397 9.46635 21.4837 8.78088 19.7198 8.78088C17.956 8.78088 16.2994 9.46635 15.056 10.7104C13.8114 11.9545 13.1265 13.6105 13.1265 15.3742C13.1265 17.1381 13.8114 18.7947 15.0554 20.0387C16.2995 21.2827 17.9561 21.9682 19.7199 21.9682C21.0091 21.9682 22.2393 21.598 23.295 20.9154L26.4124 24.1157C26.9935 24.8162 27.8511 24.8579 28.514 24.195C29.1775 23.5327 29.163 22.6467 28.4624 22.0673ZM19.7199 18.9129C18.7748 18.9129 17.886 18.5444 17.2173 17.8762C16.5493 17.2082 16.1813 16.3193 16.1813 15.3742C16.1813 14.4293 16.5493 13.541 17.2173 12.8728C17.886 12.2047 18.7743 11.8362 19.7199 11.8362C20.6644 11.8362 21.5532 12.2047 22.2213 12.8728C23.601 14.2525 23.601 16.4972 22.2213 17.8768C21.5532 18.5449 20.6649 18.9129 19.7199 18.9129Z",
    fill: "#7B2A7D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketResearch);
export default __webpack_public_path__ + "static/media/market-research.a59a112f74a8023d8401c2a931a67d6d.svg";
export { ForwardRef as ReactComponent };